import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-994fdb90"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-admin" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-admin" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-minus" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emit('hide'))),
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.userFullName), 1)
    ]),
    body: _withCtx(() => [
      ((_ctx.groupInfo.ownerId === _ctx.mainStore.user.accountId || _ctx.currentUserIsAdmin) && _ctx.user.type !== _ctx.GROUP_USER_STATUS.ADMIN)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, { key: 0 }, {
            icon: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setAsAdmin && _ctx.setAsAdmin(...args)), ["prevent"])),
                class: "btn"
              }, _toDisplayString(_ctx.$localize('group.settings.manage.popup.make')) + " " + _toDisplayString(_ctx.userFullName) + " " + _toDisplayString(_ctx.$localize('group.settings.manage.popup.make.admin')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ((_ctx.groupInfo.ownerId === _ctx.mainStore.user.accountId || _ctx.currentUserIsAdmin) && _ctx.user.type === _ctx.GROUP_USER_STATUS.ADMIN)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, { key: 1 }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.revokeAdmin && _ctx.revokeAdmin(...args)), ["prevent"])),
                class: "btn"
              }, _toDisplayString(_ctx.$localize('group.settings.manage.popup.revoke')) + " " + _toDisplayString(_ctx.userFullName) + " " + _toDisplayString(_ctx.$localize('group.settings.manage.popup.revoke.admin')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ((_ctx.groupInfo.ownerId === _ctx.mainStore.user.accountId || _ctx.currentUserIsAdmin) || _ctx.user.type === _ctx.GROUP_USER_STATUS.ADMIN)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, { key: 2 }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeUser && _ctx.removeUser(...args)), ["prevent"])),
                class: "btn"
              }, _toDisplayString(_ctx.$localize('group.settings.manage.popup.remove')) + " " + _toDisplayString(_ctx.userFullName) + " " + _toDisplayString(_ctx.$localize('group.settings.manage.popup.remove.from')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}